module.exports = __webpack_public_path__ + "img/m_soccer.a70eec98.svg";